const stepValidationRules = {
  0: [
    "name",
    "rank",
    "thumb_image:file",
    // "json_name:file",
    // "loop_Mode",
    "keyboardCategory",
  ],
  1: ["popup.bgColor:gradient", "popupBgImage:file"],
  2: ["keys.bgColor:gradient", "keysBgImage:file"],
  3: [
    "otherKeys.shift.bgColor:gradient",
    "otherKeys.numSwitch.bgColor:gradient",
    "otherKeys.emoji.bgColor:gradient",
    "otherKeys.audio.bgColor:gradient",
    "otherKeys.space.bgColor:gradient",
    "otherKeys.return.bgColor:gradient",
    "otherKeys.backspace.bgColor:gradient",
  ],
  4: ["dropDownImage:file"],
  5: [
    "fontsContent.normalBgColor:gradient",
    "fontsContent.selectedBgColor:gradient",
    "fontsContentSelectionIconImage:file",
  ],
};

const validateStep = (activeStep, formData, files) => {
  const rules = stepValidationRules[activeStep] || [];
  let isValid = true;

  const getNestedValue = (obj, pathArray) =>
    pathArray.reduce((acc, key) => acc?.[key], obj);

  for (let field of rules) {
    if (field.includes(":file")) {
      const fileKey = field.replace(":file", "");
      const path = fileKey.split(".");

      const parentPath = path.slice(0, -1);
      const parentObj = parentPath.length
        ? getNestedValue(formData, parentPath)
        : formData;

      if (
        parentObj?.popup?.bgType !== "image" ||
        parentObj?.keys?.bgType !== "image" ||
        parentObj?.fontsContent?.bgType !== "color"
      ) {
        continue;
      }

      let fileValue = getNestedValue(files, path);
      if (!fileValue) fileValue = files?.[path.join("_")];

      if (!fileValue) {
        isValid = false;
        break;
      }

      continue;
    }

    if (field.includes(":gradient")) {
      const keyPath = field.replace(":gradient", "").split(".");
      const parentPath = keyPath.slice(0, -1);

      const parentObj = getNestedValue(formData, parentPath);
      const colors = getNestedValue(formData, keyPath);

      const bgType = parentObj?.bgType || "color";

      if (bgType !== "color") continue;

      const orientationKey = Object.keys(parentObj).find((k) =>
        k.toLowerCase().includes("orientation")
      );

      const orientation = parentObj?.[orientationKey];

      if (Array.isArray(colors) && colors.length > 1 && !orientation) {
        isValid = false;
        break;
      }

      continue;
    }

    const keys = field.split(".");
    const value = getNestedValue(formData, keys);

    if (
      value === "" ||
      value === null ||
      (Array.isArray(value) && value.length === 0)
    ) {
      isValid = false;
      break;
    }
  }

  return isValid;
};

export default validateStep;
